import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Gamepad2, Home, Sparkles } from "lucide-react";
import { Helmet } from "react-helmet";

export default function NotFound() {


  return (
    <main className="relative pb-10 min-h-screen overflow-hidden bg-[#050A1A] text-white flex items-center justify-center px-5 xs:px-5 sm:px-6 md:px-8">
       <Helmet>
        <title>404 Page Not Found | Game Zone</title>
        <meta name="description" content="The page you are looking for does not exist. Go back to Game Zone to play free online games." />
        
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] bg-blue-600/30 rounded-full blur-[160px]" />
      <div className="absolute top-1/3 -right-40 w-[500px] h-[500px] bg-purple-600/30 rounded-full blur-[160px]" />
      <div className="absolute bottom-0 left-1/2 w-[400px] h-[400px] bg-cyan-500/20 rounded-full blur-[160px]" />

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="relative z-10 max-w-2xl w-full"
      >
        <div className="bg-white/5 mt-10 backdrop-blur-xl border border-white/10  rounded-2xl sm:rounded-3xl  shadow-2xl  p-6 xs:p-7 sm:p-8 md:p-10  text-center">
          <motion.div
            animate={{ y: [0, -10, 0] }}
            transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
            className="flex justify-center mb-6"
          >
            <Gamepad2 className=" w-14 h-14  xs:w-16 xs:h-16  sm:w-18 sm:h-18  md:w-20 md:h-20  text-cyan-400" />
          </motion.div>

          <h1 className=" text-[65px]  xs:text-[70px]  sm:text-[100px]  md:text-[120px]  leading-none font-extrabold  bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-500  bg-clip-text text-transparent">
            404
          </h1>

          <h2 className="text-xl xs:text-2xl sm:text-3xl font-bold mt-3 sm:mt-4 mb-2 sm:mb-3">
            Game Over!
          </h2>

          <p className="text-gray-300 text-sm xs:text-base max-w-xs xs:max-w-sm sm:max-w-md mx-auto mb-6 sm:mb-8">
            Looks like this level doesn’t exist. The page you’re trying to reach is missing or broken.
            Don’t worry — your next adventure is just one click away.
          </p>

        <div className="flex text-sm xs:text-base flex-col xs:flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-8 sm:mt-12">
           <Link
             to="/"
             className="flex items-center justify-center gap-2 px-6 py-3 rounded-xl 
                        bg-gradient-to-r from-cyan-500 to-blue-500 text-white 
                        font-semibold shadow-lg 
                        hover:shadow-[0_0_30px_rgba(56,189,248,0.5)] 
                        transition"
           >
             <Home className="w-5 h-5" />
             Back to Home
           </Link>
         
           <Link
             to="/games"
             className="flex items-center justify-center gap-2 px-6 py-3 rounded-xl 
                        bg-white/10 border border-white/20 
                        text-gray-200 font-medium 
                        hover:border-cyan-400/40 hover:text-white 
                        transition"
           >
             <Sparkles className="w-5 h-5 text-yellow-400" />
             Explore Games
           </Link>
        </div>

        </div>

        
      </motion.div>
    </main>
  );
}